import * as yup from 'yup';

export const SampleReceiptSchema = yup.object().shape({
  title: yup.string().required('Title is required'),
  receipt: yup.string().required('Receipt data is required')
});
